import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function CancelSubscriptionModal({
  show,
  planName,
  periodEndLabel,
  isSubmitting,
  onClose,
  onConfirm,
}) {
  return (
    <Modal centered show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Cancel subscription?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your
          {' '}
          <strong>{planName}</strong>
          {' '}
          subscription will stay active until
          {' '}
          <strong>{periodEndLabel}</strong>
          . After that date, billing stops and paid features will end unless you subscribe again.
        </p>
        <p className="mb-0">
          You can keep using LocShark until the end of your current billing period.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Keep subscription
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Canceling…' : 'Cancel at period end'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CancelSubscriptionModal;
